var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9623 6.94339L11.0189 0V6.94339H17.9623Z",
    fill: "#ED676A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01887 0C1.35159 0 0 1.35159 0 3.01887V20.9811C0 22.6484 1.35159 24 3.01887 24H14.9434C16.6107 24 17.9623 22.6484 17.9623 20.9811V6.94339H11.0189V0H3.01887Z",
    fill: "#E5252A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81841 13.7045C6.56214 14.0154 6.88603 14.8459 6.55517 15.594C6.2902 16.193 5.91305 16.4035 5.104 16.4039L4.46772 16.4042V17.2056V18.0069H3.85502H3.24231V15.7914V13.5759H4.37648C5.12115 13.5759 5.61631 13.62 5.81841 13.7045ZM9.67837 13.7648C10.4514 14.054 10.885 14.6084 11.0097 15.4665C11.1557 16.4707 10.686 17.37 9.80025 17.7825C9.38371 17.9765 9.17972 18.0052 8.21466 18.006L7.10708 18.0069V15.7914V13.5759H8.14038C8.9435 13.5759 9.28624 13.618 9.67837 13.7648ZM14.7423 14.0945V14.613H13.7526H12.7628V14.9429V15.2729H13.5641H14.3653V15.7443V16.2157H13.5641H12.7628V17.1113V18.0069H12.1501H11.5374V15.7914V13.5759H13.1399H14.7423V14.0945ZM4.46772 15.0372C4.46772 15.4607 4.46829 15.4615 4.80386 15.4615C5.25105 15.4615 5.50461 15.3135 5.50461 15.0528C5.50461 14.7369 5.32664 14.613 4.87305 14.613H4.46772V15.0372ZM8.23823 15.8493V17.0856L8.68598 17.0224C9.43998 16.9161 9.83655 16.503 9.83928 15.8211C9.8423 15.0638 9.39521 14.614 8.63885 14.6134L8.23823 14.613V15.8493Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3866524ea108b666d995ea1209d9ce6f.svg";
export { ForwardRef as ReactComponent };